import React from "react";
import { useTranslation } from "react-i18next";
import { fs, T } from "./tokens";

// values are on the displayed scale (0..max)
const Sparkline: React.FC<{ values: number[]; color: string; max: number }> = ({ values, color, max }) => {
  const { t } = useTranslation();
  if (values.length < 2) {
    return (
      <p style={{ ...fs("xs"), color: T.color.text.secondary, margin: 0 }}>
        {t("lifeAreas.sparkEmpty")}
      </p>
    );
  }
  const W = 220;
  const H = 44;
  const pts = values.map((v, i) => [
    (i / (values.length - 1)) * (W - 12) + 6,
    H - 6 - (Math.max(0, Math.min(max, v)) / max) * (H - 12),
  ]);
  const line = pts.map((p) => p.join(",")).join(" ");
  const last = pts[pts.length - 1];
  return (
    <svg
      width={W}
      height={H}
      role="img"
      aria-label={t("lifeAreas.sparkLabel", { count: values.length, values: values.join(", ") })}
    >
      <polyline
        points={line}
        fill="none"
        stroke={color}
        strokeWidth={2.5}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={last[0]} cy={last[1]} r={4} fill={color} />
    </svg>
  );
};

export default Sparkline;
